import { render } from "./download_overlay.vue?vue&type=template&id=21c436e3&scoped=true"
import script from "./download_overlay.vue?vue&type=script&lang=js"
export * from "./download_overlay.vue?vue&type=script&lang=js"

import "./download_overlay.vue?vue&type=style&index=0&id=21c436e3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c436e3"]])

export default __exports__